import { ManagerData } from 'api/types/data';
import { GridFields } from 'components';
import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';
import {
  Field,
  useFormContext,
} from 'modules/client/common/forms/accountCodesForm';

interface Props {
  managers: ManagerData[];
  managersLoading?: boolean;
  isEditablePersonalAccountNumber?: boolean;
}

export const AccountCodesSection = ({
  managers,
  managersLoading,
  isEditablePersonalAccountNumber,
}: Props) => {
  const { t } = useTranslation();
  const { readOnly } = useFormContext();

  return (
    <Section
      datax="accountCodesSection"
      title={t('client.client.accountCodes.title')}
    >
      <GridFields>
        <Field.Text
          fullWidth
          label={t('client.client.accountCodes.personalAccountNumber.label')}
          name="accountCodes.personalAccountNumber"
          placeholder={t(
            'client.client.accountCodes.personalAccountNumber.placeholder'
          )}
          readOnly={isEditablePersonalAccountNumber ? readOnly : true}
        />
        <Field.DatePicker
          fullWidth
          label={t(
            'client.client.accountCodes.personalAccountOpeningDate.label'
          )}
          name="accountCodes.personalAccountOpeningDate"
          placeholder={t(
            'client.client.accountCodes.personalAccountOpeningDate.placeholder'
          )}
          readOnly={isEditablePersonalAccountNumber ? readOnly : true}
        />

        <Field.Text
          label={t('client.client.accountCodes.code.label')}
          name="accountCodes.code"
          placeholder={t('client.client.accountCodes.code.placeholder')}
        />

        <Field.Text
          fullWidth
          label={t(
            'client.client.accountCodes.centralDepositoryAccountNumber.label'
          )}
          name="accountCodes.centralDepositoryAccountNumber"
          placeholder={t(
            'client.client.accountCodes.centralDepositoryAccountNumber.placeholder'
          )}
        />

        <Field.DatePicker
          fullWidth
          label={t(
            'client.client.accountCodes.centralDepositoryAccountNumberOpeningDate.label'
          )}
          name="accountCodes.centralDepositoryAccountNumberOpeningDate"
          placeholder={t(
            'client.client.accountCodes.centralDepositoryAccountNumberOpeningDate.placeholder'
          )}
        />

        <Field.Autocomplete
          label={t('client.client.accountCodes.manager.label')}
          loading={managersLoading}
          name="accountCodes.manager"
          optionLabelKey="name"
          options={managers}
          optionValueKey="id"
          placeholder={t('client.client.accountCodes.manager.placeholder')}
        />

        <Field.DatePicker
          fullWidth
          disableFuture={false}
          label={t(
            'client.client.accountCodes.personalAccountClosingDate.label'
          )}
          name="accountCodes.personalAccountClosingDate"
          placeholder={t(
            'client.client.accountCodes.personalAccountClosingDate.placeholder'
          )}
        />
        <Field.DatePicker
          fullWidth
          disableFuture={false}
          label={t(
            'client.client.accountCodes.personalAccountFreezingDate.label'
          )}
          name="accountCodes.personalAccountFreezingDate"
          placeholder={t(
            'client.client.accountCodes.personalAccountFreezingDate.placeholder'
          )}
        />
      </GridFields>
    </Section>
  );
};
